import { render, staticRenderFns } from "./UtilityReportDetails.vue?vue&type=template&id=21dfc730"
import script from "./UtilityReportDetails.vue?vue&type=script&lang=js"
export * from "./UtilityReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports